'use strict';

var _lodash = require('lodash');

var footerSingleCompCovert = function footerSingleCompCovert(obj, lang) {
    return {
        cssDisatance: (0, _lodash.get)(obj, ['data', 'cssDistance']),
        url: (0, _lodash.get)(obj, ['data', 'actionUrl', lang], ""),
        title: (0, _lodash.get)(obj, ['data', 'title', lang]),
        icon: (0, _lodash.get)(obj, ['data', 'icon', 'iv']),
        color: (0, _lodash.get)(obj, ['data', 'color', 'iv'], '#00508B'),
        img: (0, _lodash.get)(obj, ['data', 'image', lang, 0, 'url']),
        subpage: !(0, _lodash.isEmpty)((0, _lodash.get)(obj, ['data', 'subNav', 'iv'])) && obj.data.subNav.iv.map(function (item) {
            return footerSingleCompCovert(item, lang);
        })
    };
};

var headerSingleCompCovert = function headerSingleCompCovert(obj, lang) {
    return {
        cssDisatance: (0, _lodash.get)(obj, ['data', 'cssDistance']),
        url: (0, _lodash.get)(obj, ['data', 'actionUrl', lang], ""),
        title: (0, _lodash.get)(obj, ['data', 'title', lang]),
        icon: (0, _lodash.get)(obj, ['data', 'icon', 'iv']),
        iconPic: (0, _lodash.get)(obj, ['data', 'iconPic', 'iv', 0, 'url']),
        color: (0, _lodash.get)(obj, ['data', 'color', 'iv'], '#00508B'),
        bgColor: (0, _lodash.get)(obj, ['data', 'bgColor', 'iv']),
        bold: (0, _lodash.get)(obj, ['data', 'bold', 'iv']),
        subNav: {
            content: !(0, _lodash.isEmpty)((0, _lodash.get)(obj, ['data', 'subNav', 'iv'])) && obj.data.subNav.iv.map(function (item) {
                return headerSingleCompCovert(item, lang);
            })
        },
        key: (0, _lodash.get)(obj, ['data', 'key', 'iv'])
    };
};

var singleBtnConverter = function singleBtnConverter(raw, lang) {
    if (!raw || !raw.data) {
        return null;
    }
    var data = raw.data;
    var res = {
        name: (0, _lodash.get)(data, 'name.iv', null),
        buttonType: (0, _lodash.get)(data, 'buttonType.iv[0].data.name.iv'),
        anchor: (0, _lodash.get)(data, 'anchor.iv'),
        text: (0, _lodash.get)(data, 'text[' + lang + ']'),
        actionValue: (0, _lodash.get)(data, 'actionValue[' + lang + ']'),
        action: (0, _lodash.get)(data, 'action.iv[0].data.action.iv'),
        color: (0, _lodash.get)(data, 'color.iv[0].data.color.iv'),
        img: (0, _lodash.get)(data, 'img[' + lang + '][0]'),
        imgMobile: (0, _lodash.get)(data, 'imgMobile[' + lang + '][0]'),
        isImgBtn: !(0, _lodash.isEmpty)((0, _lodash.get)(data, 'img[' + lang + '][0]')) || !(0, _lodash.isEmpty)((0, _lodash.get)(data, 'imgMobile[' + lang + '][0]')),
        imageHeight: (0, _lodash.get)(data, 'imageHeight.iv'),
        imageHeightMobile: (0, _lodash.get)(data, 'imageHeightMobile.iv'),
        imageWidth: (0, _lodash.get)(data, 'imageWidth.iv'),
        imageWidthMobile: (0, _lodash.get)(data, 'imageWidthMobile.iv')
    };

    return res;
};

var footer = function footer(rawData) {
    var temp = JSON.parse(JSON.stringify(rawData));
    var data = temp[0].data;

    var cn = {
        copyright: (0, _lodash.get)(data, ['copyright', 'zh_HK']),
        subpages: data.subpages.iv.map(function (item) {
            return footerSingleCompCovert(item, 'zh_HK');
        }),
        otherLinks: data.otherLink.iv.map(function (item) {
            return footerSingleCompCovert(item, 'zh_HK');
        }),
        footerIcon: data.footerIcon.iv.map(function (item) {
            return footerSingleCompCovert(item, 'zh_HK');
        }),
        pages: data.pages.iv.map(function (item) {
            return footerSingleCompCovert(item, 'zh_HK');
        })
    };

    var en = {
        copyright: (0, _lodash.get)(data, ['copyright', 'en']),
        subpages: data.subpages.iv.map(function (item) {
            return footerSingleCompCovert(item, 'en');
        }),
        otherLinks: data.otherLink.iv.map(function (item) {
            return footerSingleCompCovert(item, 'en');
        }),
        footerIcon: data.footerIcon.iv.map(function (item) {
            return footerSingleCompCovert(item, 'en');
        }),
        pages: data.pages.iv.map(function (item) {
            return footerSingleCompCovert(item, 'en');
        })
    };

    return { cn: cn, en: en };
};

var header = function header(rawData) {
    var temp = JSON.parse(JSON.stringify(rawData));
    var data = temp[0].data;

    var en = {
        login: (0, _lodash.get)(data, ['login', 'en']),
        topMiniNav: data.topMiniNav.iv.map(function (item) {
            return headerSingleCompCovert(item, 'en');
        }),
        pages: data.pages.iv.map(function (item) {
            return headerSingleCompCovert(item, 'en');
        }),
        ctaButton: data.ctaButton ? data.ctaButton.iv.map(function (item) {
            return singleBtnConverter(item, 'en');
        }) : null
    };

    var cn = {
        login: (0, _lodash.get)(data, ['login', 'zh_HK']),
        topMiniNav: data.topMiniNav.iv.map(function (item) {
            return headerSingleCompCovert(item, 'zh_HK');
        }),
        pages: data.pages.iv.map(function (item) {
            return headerSingleCompCovert(item, 'zh_HK');
        }),
        ctaButton: data.ctaButton ? data.ctaButton.iv.map(function (item) {
            return singleBtnConverter(item, 'zh_HK');
        }) : null
    };
    return {
        en: en,
        cn: cn
    };
};

module.exports = {
    footer: footer,
    header: header
};